/* eslint-disable */
import store from "@/store";
const onlyAuth = (to, from, next) => {
  if (!store.getters.isDirectorAuthenticated) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    next("/login");
  } else {
    next();
  }
};

export default [
  {
    meta: {
      title: "Obituary"
    },
    path: "/",
    name: "Obituary",
    // beforeEnter: onlyAuth,
    component: () => import("@/views/obituary/Obituary.vue")
  },
  {
    meta: {
      title: "ObituaryReply"
    },
    path: "/reply",
    name: "ObituaryReply",
    // beforeEnter: onlyAuth,
    component: () => import("@/views/obituary/reply.vue")
  },
  {
    meta: {
      title: "ObituarySetting"
    },
    path: "/setting",
    name: "ObituarySetting",
    // beforeEnter: onlyAuth,
    component: () => import("@/views/obituary/setting.vue")
  }
];
